/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import styled from 'styled-components';
import Config from '../../../Config';

export const MetaAnchor = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
`;

export const MetadataPopover = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    white-space: nowrap;
    z-index: 20;

    padding: 16px;
    background: #fff;
    box-shadow: 0 2px 6px 0 #00000040;
`;

export const ModalWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const MetaLink = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    font-size: 12px;
    font-weight: 700;
    color: ${Config.color.motiliLightBlue};
    text-transform: uppercase;
    text-decoration: underline;
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Row = styled.div`
    flex: 1;
    display: flex;
    gap: 4px;
`;

export const Label = styled.div<{ invalid?: boolean }>`
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 20px;
    letter-spacing: 0;
    min-width: 110px;
    color: ${props => (props.invalid ? '#e63232' : undefined)};
`;

export const Value = styled.div`
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    text-transform: uppercase;
    line-height: 20px;
    letter-spacing: 0;
`;
